import { MediaItemDtoSchema } from "@modules/sessionBlock/media/mediaDto"
import { z } from "zod"

enum ScoreDifficultyEnum {
  RX = "RX",
  SCALED = "SCALED",
}

export const ScoreDtoSchema = z.object({
  value: z.number(),
  difficulty: z.nativeEnum(ScoreDifficultyEnum),
  note: z.string(),
})

export type ScoreDto = z.infer<typeof ScoreDtoSchema>

export const DashboardScoreDtoSchema = z.object({
  value: z.number(),
  type: z.string(),
})

export type DashboardScoreDto = z.infer<typeof DashboardScoreDtoSchema>

export const ScoreBoardDetailDtoSchema = z.object({
  value: z.number(),
  difficulty: z.nativeEnum(ScoreDifficultyEnum),
  note: z.string().optional(),
  noteAndMediaIsVisible: z.boolean(),
  medias: z.array(MediaItemDtoSchema).optional(),
})

export type ScoreBoardDetailDto = z.infer<typeof ScoreBoardDetailDtoSchema>
